module.exports = __webpack_public_path__ + "img/guide_dir_01.5dcaed84.png";